<template>
  <div class="record-page">
    <div class="header">
      <div class="left-area" @click="goBack">
        <van-icon name="arrow-left" size="30" color="#2E89C6" />
      </div>
      <div class="center-area">
        <h1 class="title">録音時間</h1>
      </div>
      <div class="right-area">
        <van-button
            class="record-button"
            type="primary"
            @click="startNewRecording"
        >
          新録音開始
        </van-button>
      </div>
    </div>

    <div class="content-container">
      <div class="timer">
        <span>{{ elapsedTimeFormatted }}</span> &nbsp;
        <span v-if="showRemainingTime" class="remaining-time">
          (残り{{ remainingTimeFormatted }})-->
        </span>
      </div>

      <p class="hint-text">
        ※30分以上超過する場合、録音は自動的に終了します
      </p>

      <div class="checklist-area">
        <div v-if="checklistItems.length === 0" class="no-template-message">
          <span>録音テンプレートがありません</span>
        </div>
        <div v-else
            class="checklist-item"
            v-for="(item, index) in checklistItems"
            :key="index"
        >
          <template v-if="item.itemType === 'checkbox' && item.checkItem === 1">
            <div class="check-title-row">
              <span class="check-index">{{ index + 1 }}.</span>
              <van-checkbox
                  v-model="checklistAnswers[index]"
                  shape="square"
              />
              <span class="check-label">{{ item.label }}</span>
            </div>
          </template>

          <template v-else-if="item.itemType === 'text'">
            <div class="checklist-label">{{ index + 1 }}. {{ item.label }}</div>
            <van-field
                v-model="checklistAnswers[index]"
                placeholder="入力してください"
                input-align="left"
                class="custom-input"
            />
          </template>

          <!-- radio 单选题 -->
          <template v-else-if="item.itemType === 'radio'">
            <div class="checklist-label">{{ index + 1 }}. {{ item.label }}</div>
            <van-radio-group
                v-model="checklistAnswers[index]"
                direction="vertical"
            >
              <van-radio
                  v-for="(option, optIdx) in item.options"
                  :key="optIdx"
                  :name="optIdx"
                  checked-color="#1989fa"
              >
                {{ option }}
              </van-radio>
            </van-radio-group>
          </template>

          <!-- checkbox 多选题 -->
          <template v-else-if="item.itemType === 'checkbox'">
            <div class="checklist-label">{{ index + 1 }}. {{ item.label }}</div>
            <van-checkbox-group v-model="checklistAnswers[index]">
              <van-checkbox
                  v-for="(option, optIdx) in item.options"
                  :key="optIdx"
                  :name="optIdx"
                  shape="square"
              >
                {{ option }}
              </van-checkbox>
            </van-checkbox-group>
          </template>

        </div>
        <div class="checklist-button" v-if="checklistItems.length > 0">
          <van-button class="record-button"
                      type="primary"
                      @click="updateCheckList">
            更新
          </van-button>
        </div>
      </div>

      <div class="mic-container">
        <div class="mic-button" @click="toggleRecording">
          <img :src="isRecording
              ? require('@/assets/img/recordaudio/record_off.svg')
              : require('@/assets/img/recordaudio/record_on.svg')
            "
              alt="録音"
              class="mic-icon"
          />
        </div>
        <div class="mic-hint">
          {{isRecording ? 'クリックすると、録音を終了' : 'クリックすると、録音を開始' }}
        </div>
      </div>
    </div>

    <van-popup v-model:show="recordPopUpShow" round position="center">
      <div class="memo-popup" @click.stop>
        <div class="memo-title">病棟号を入力してください</div>
        <van-field
            v-model="memo"
            type="text"
            placeholder="病棟号を入力してください"
            class="memo-input"
        />
        <div class="memo-hint">
          ※30分以上経過すると、録音は自動的に終了します
        </div>
        <div class="memo-buttons">
          <van-button type="default" @click.stop="recordPopUpShow = false">
            キャンセル
          </van-button>
          <van-button type="primary" @click.stop="startAudioRecording">
            OK
          </van-button>
        </div>
      </div>
    </van-popup>

    <van-popup v-model:show="recordNoticePopUpShow" round position="center">
      <div class="memo-popup" @click.stop>
        <div class="memo-title">{{ recordNoticeMessage }}</div>
        <div class="memo-buttons single-button">
          <van-button
              type="primary"
              @click.stop="recordNoticePopUpShow = false"
          >
            OK
          </van-button>
        </div>
      </div>
    </van-popup>
  </div>
</template>

<script>
import { Dialog, Toast } from "vant";
import {getCheckListTemplate, updateCheckListLog, uploadRecordAudio} from "@/services/video";

export default {
  data() {
    return {
      isRecording: false,
      audioChunks: [],
      audioStream: null,
      audioRecorder: null,
      recordNoticeMessage: "",
      recordNoticePopUpShow: false,
      recordId: null,
      memo: "",
      elapsedSeconds: 0,
      warningTime: 5 * 60,
      maxRecordTime: 30 * 60,
      timerInterval: null,
      showRemainingTime: false,
      recordPopUpShow: false,
      playMsgRinging: false,
      checklistItems: [],
      checklistAnswers: {},
      checklistTemplateId:null,
      lastAudioRecordId:null,
      checklistlogId:null,
    };
  },
  computed: {
    elapsedTimeFormatted() {
      const minutes = Math.floor(this.elapsedSeconds / 60);
      const seconds = this.elapsedSeconds % 60;
      return `${minutes.toString().padStart(2, '0')}分${seconds.toString().padStart(2, '0')}秒`;
    },
    remainingTimeFormatted() {
      const remainingSeconds = this.warningTime - (this.elapsedSeconds - (this.maxRecordTime - this.warningTime));
      const minutes = Math.floor(remainingSeconds / 60);
      const seconds = remainingSeconds % 60;
      return `${minutes.toString().padStart(2, '0')}分${seconds.toString().padStart(2, '0')}秒`;
    }
  },
  created() {
  },
  mounted() {
    this.memo = this.$route.query.memo;
    // 判断是否需要开启录音
    if(this.$route.query.startRecord === 'true'){
      this.startAudioRecording();
    }
    const newPath = this.$router.resolve({
      path: this.$route.path
    }).href;
    window.history.replaceState(null, '', newPath);

    window.addEventListener('beforeunload', this.handleBeforeUnload);
    this.checkIsHaveTemplate();
  },
  beforeUnmount() {
    this.stopAudioRecording();
    this.clearTimer();
    window.removeEventListener('beforeunload', this.handleBeforeUnload);
  },
  methods: {
    async updateCheckList(){
      if(!this.lastAudioRecordId){
        Toast("まず録音を開始してください");
        return;
      }
      let checklist_data = {
        checklists_id:JSON.stringify(this.checklistTemplateId),
        answers:JSON.stringify(this.checklistAnswers),
        audiorecord_id:this.lastAudioRecordId
      };
      if(this.checklistlogId){
        checklist_data['id'] = this.checklistlogId;
      }
      const res = await updateCheckListLog(checklist_data);
      if(res.data.code >= 0){
        this.checklistlogId = res.data.data.id;
        Toast("更新に成功しました");
      }else{
        Toast("更新に失敗しました");
      }
      console.log(res);
    },
    async checkIsHaveTemplate(){
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      const res = await getCheckListTemplate({login_account_id: user.login_account_id});
      try {
        this.checklistItems = JSON.parse(res.data.data.template_json);
        this.checklistTemplateId = JSON.parse(res.data.data.id);
        // 初始化答案结构
        this.checklistAnswers = {};
        this.checklistItems.forEach((item, index) => {
          if (item.itemType === 'checkbox') {
            this.checklistAnswers[index] = item.checkItem === 1 ? false : [];
          } else if (item.itemType === 'radio') {
            this.checklistAnswers[index] = '';
          } else {
            this.checklistAnswers[index] = '';
          }
        });
      } catch (e) {
        console.error("テンプレート解析失敗:", e);
        this.checklistItems = [];
      }
    },
    handleBeforeUnload(event) {
      if (this.isRecording) {
        event.preventDefault();
        event.returnValue = '録音中です。録音は保存されません。';
      }
    },
    goBack() {
      if (this.isRecording) {
        Dialog.confirm({
          message: '録音中ですが、退出してもよろしいですか？',
          confirmButtonText: "確認",
          cancelButtonText: "キャンセル",
        })
        .then(async() => {
          this.$router.go(-1);
        })
        .catch(() => {

        })
      }else{
        this.$router.go(-1);
      }
    },
    changeRecordStatus(value){
      this.isRecording = value;
      this.$emit("doMethods",
          {"method":"changeRecordAudioStatus","value":value});
    },
    resetRecordAudioData() {
      this.clearTimer();
      if (this.audioStream) {
        this.audioStream.getTracks().forEach((t) => t.stop());
        this.audioStream = null;
      }
      this.isRecording = false;
      this.audioRecorder = null;
      this.audioChunks = [];
      this.recordId = null;
      this.memo = "";
      this.audioStream = null;
      this.playMsgRinging = false;
    },
    async startAudioRecording(){
      // 清空checklist
      this.checkIsHaveTemplate();
      this.checklistlogId = null;

      this.changeRecordStatus(true);
      this.audioChunks = [];
      this.startTimer();
      const user = JSON.parse(localStorage.getItem(process.env.VUE_APP_USER_KEY));
      const params = {
        status: "ready",
        record_user: user.login_account_id,
        memo: this.memo ? this.memo :"",
      };
      const form = new FormData();
      form.append("params", JSON.stringify(params));
      const res = await uploadRecordAudio(form);
      if (res.data.code >= 0) {
        this.recordId = res.data.data.id;
        this.lastAudioRecordId = res.data.data.id;
      } else {
        Toast("録音の開始に失敗しました");
        this.changeRecordStatus(false);
        return;
      }
      navigator.mediaDevices
          .getUserMedia({ audio: true })
          .then((stream) => {
            this.audioStream = stream;
            this.audioRecorder = new MediaRecorder(stream);
            this.audioRecorder.ondataavailable = (e) => {
              if (e.data.size) this.audioChunks.push(e.data);
            };
            this.audioRecorder.start(100);
          })
          .catch(() => {
            Toast("マイクにアクセスできませんでした");
            this.changeRecordStatus(false);
          });
      this.recordPopUpShow = false;
    },
    async stopAudioRecording(isTimeout = false,showPop = true){
      this.changeRecordStatus(false);
      this.recordNoticeMessage = isTimeout
          ? "30分以上経過すると、録音は自動的に終了します、再度操作して録音してください。"
          : "録音が正常に完了しました。";
      if(showPop){
        this.recordNoticePopUpShow = true;
      }
      if (this.audioRecorder && this.audioRecorder.state !== "inactive") {
        this.audioRecorder.onstop = async () =>
          await this.generateAudioFile(this.audioChunks);
        this.audioRecorder.stop();
      } else {
        this.resetRecordAudioData();
      }
    },
    async generateAudioFile(chunks) {
      if (!chunks.length) return;
      const blob = new Blob(chunks, { type: "audio/wav" });
      const params = { status: "upload", id: this.recordId };
      const form = new FormData();
      form.append("audio", blob, "audio.wav");
      form.append("params", JSON.stringify(params));
      Toast.loading({
        message: "アップロード中...",
        forbidClick: true,
        duration: 0,
        overlay: true,
      });
      await uploadRecordAudio(form);
      Toast.clear();
      this.resetRecordAudioData();
    },
    startTimer() {
      this.elapsedSeconds = 0;
      this.showRemainingTime = false;
      this.clearTimer();
      this.timerInterval = setInterval(() => {
        this.elapsedSeconds++;
        if (this.elapsedSeconds >= (this.maxRecordTime - this.warningTime)) {
          this.showRemainingTime = true;
          if(!this.playMsgRinging){
            this.playMsgRinging = true;
            this.$emit("doMethods", {"method":"playMsgRinging"});
          }
        }
        if (this.elapsedSeconds >= this.maxRecordTime) {
          this.$emit("doMethods", {"method":"playMsgRinging"});
          this.stopAudioRecording(true);
          this.clearTimer();
          Toast("録音時間が30分を超えたため、録音を終了しました");
        }
      }, 1000);
    },
    clearTimer() {
      if (this.timerInterval) {
        clearInterval(this.timerInterval);
        this.timerInterval = null;
      }
    },
    toggleRecording() {
      if (this.isRecording) {
        this.stopAudioRecording();
      } else {
        this.recordPopUpShow = true;
      }
    },
    async startNewRecording() {
      if (this.isRecording) {
        await this.stopAudioRecording(false,false);
      }
      this.recordPopUpShow = true;
    },
  },
};
</script>

<style scoped>
.record-page {
  display: flex;
  flex-direction: column;
  align-items: center;
  padding: 0;
  height: 100%;
  box-sizing: border-box;
  position: relative;
  overflow: hidden;
}

.header {
  width: 85%;
  display: flex;
  align-items: center;
  justify-content: space-between;
  height: 60px;
  padding: 0 10px;
}

.left-area,
.center-area,
.right-area {
  width: 33.33%;
  display: flex;
  align-items: center;
  justify-content: center;
}
.left-area{
  justify-content: left;
}
.right-area{
  justify-content: right;
}

.center-area .title {
  font-size: 30px;
  font-weight: bold;
}

.content-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: flex-start;
  width: 100%;
  height: 100%;
  padding-top: 20px;
  box-sizing: border-box;
  overflow: hidden;
}

.timer {
  font-size: 40px;
  font-weight: bold;
  margin: 20px 0 10px;
  text-align: center;
  line-height: 1.2;
}

.remaining-time {
  color: red;
}

.hint-text {
  font-size: 18px;
  color: #666;
  margin-top: 0;
  margin-bottom: 10px;
  text-align: center;
}

.checklist-area {
  flex: 1;
  overflow-y: auto;
  width: 90%;
  background: #fff;
  border-radius: 8px;
  padding: 16px;
  box-sizing: border-box;
}

.checklist-button{
  display: flex;
  justify-content: center;
}

.checklist-item {
  margin-bottom: 20px;
  padding-bottom: 12px;
  border-bottom: 1px solid #eaeaea;
}

.checklist-label {
  font-weight: bold;
  margin-bottom: 10px;
  font-size: 18px;
}

.check-title-row {
  display: flex;
  gap: 10px;
  font-size: 18px;
}

.check-index {
  font-weight: bold;
}

.check-label {
  flex: 1;
  font-size: 18px;
}

.custom-input .van-field__control {
  border: 1px solid #ccc;
  padding: 8px;
  border-radius: 6px;
  background-color: #fff;
}

.van-radio,
.van-checkbox {
  margin-bottom: 8px;
}

.mic-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  margin-top: 10px;
  margin-bottom: 20px;
}

.mic-button {
  cursor: pointer;
}

.mic-icon {
  width: 120px;
  height: 120px;
}

.mic-hint {
  font-size: 18px;
  text-align: center;
  margin-top: 10px;
}

.record-button {
  background-color: #2e89c6;
  border-radius: 8px;
  font-size: 18px;
  padding: 5px 10px;
  width: auto;
  height: auto;
  font-weight: bold;
  margin: 0;
  color: #fff;
}

.memo-popup {
  background-color: #e6f2ff;
  padding: 20px;
  width: 80vw;
  max-width: 350px;
}

.memo-title {
  font-size: 25px;
  font-weight: bold;
  margin-bottom: 15px;
  text-align: center;
}

.memo-input {
  margin-bottom: 10px;
}

.memo-hint {
  font-size: 18px;
  color: #666;
  margin-bottom: 15px;
}

.memo-buttons {
  display: flex;
  justify-content: space-evenly;
}

.memo-buttons .van-button {
  width: 45%;
}
.no-template-message {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 24px;
  font-weight: bold;
}
</style>